// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".features__box--wrapper h3{word-break:normal;-webkit-hyphens:auto;hyphens:auto}@media(min-width:375px){.features__box--wrapper h3{-webkit-hyphens:none;hyphens:none}}@media(min-width:768px){.features__box--wrapper h3{font-size:38px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
